// extracted by mini-css-extract-plugin
module.exports = {"modal__player":"footer-module--modal__player--coooe","footer":"footer-module--footer--3dt86","copyright":"footer-module--copyright--2bQp3","hide":"footer-module--hide--lZ9Qq"};